"use strict";

jQuery(document).ready(function ($) {
  $('a[data-cc_block_id].course-cards__filter').click(function (e) {
    $(this).addClass('active').siblings().removeClass('active');
    e.preventDefault(); // this line prevents changing to the URL of the link href
    e.stopPropagation(); // this line prevents the link click from bubbling

    // retrieve Unique Block id
    var cc_block_id = $(this).data('cc_block_id');
    $('#cc_level_' + cc_block_id).val($(this).data('cc_block_value'));
    $('#cc_paged_' + cc_block_id).val(1);
    performCourseCardSearch(cc_block_id);
  });

  //  Handle pagination clicks
  $(document).on('click', '.course-cards__pagination .pagination .page-numbers', function (e) {
    // retrieve Unique Block id
    var cc_block_id = $(this).data('cc_block_id');
    e.preventDefault();
    var page = $(this).data('page');
    $('#cc_paged_' + cc_block_id).val(page);
    performCourseCardSearch(cc_block_id);
  });
  function performCourseCardSearch(cc_block_id) {
    var formData = $('#cc_form_' + cc_block_id).serialize();
    //var jsonData = JSON.stringify(formData);
    var ajaxurl = ajax.ajax_url; // Use WordPress ajax_url

    $.ajax({
      type: 'POST',
      url: ajaxurl,
      dataType: "json",
      encode: true,
      data: {
        'action': 'course_card_search',
        'cc_block_id': cc_block_id,
        'formData': formData
      },
      success: function success(response) {
        $('#current_page_' + cc_block_id).html(response.current_page);
        $('#max_num_pages_' + cc_block_id).html(response.max_num_pages);
        $('#cc_results_' + cc_block_id).html(response.result);
        $('#searchPagination_' + cc_block_id).html(response.pagination);
      },
      error: function error(response) {
        $('#searchResults').html(response.result);
      }
    });
  }
});